<template>
  <b-modal
      id="delete-simulation-reason"
      hide-footer
      centered
      size="md"
      hide-header
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      modal-class="giga-modal"
      content-class="giga-modal_content"
  >
    <h2 class="giga-modal_title" v-if="modalTitle" v-html="modalTitle"></h2>

    <div class="giga-modal_body">
      <p class="giga-content_label">
        <span v-html="content"></span>
        <span class="text-danger">*</span>
      </p>

      <div class="form-group">
        <b-form-select
            v-model="reason"
            :options="reasonOptions"
            placeholder="Sélectionner une raison"
            @change="handleReasonChange"
            :class="['custom-input-style', { 'is-invalid': $v.reason.$error }]"
        />
        <div v-if="$v.reason.$anyDirty && $v.reason.$invalid">
          <small class="form-text text-danger">
            {{ $t("required_field") }}
          </small>
        </div>
      </div>

      <div class="giga-fields">
        <div class="col-lg-12">
          <div class="giga-input_field">
            <label class="input-field_label">
              Commentaire
              <span v-if="reason === 'AUTRE'" class="text-danger">*</span>
            </label>
            <div class="input-field_area">
              <b-form-textarea
                  v-model="message"
                  rows="3"
                  :placeholder="messagePlaceholder"
                  :class="{ 'is-invalid': $v.message.$error }"
              />
            </div>
            <div v-if="$v.$dirty && reason === 'AUTRE' && !$v.message.required">
              <small class="form-text text-danger">
                {{ $t("required_field") }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="giga-modal_footer">
      <div class="giga-button">
        <button class="giga-blue_outlined_button no-icon" @click="onCancel">
          {{ $t("cancel") }}
        </button>
      </div>
      <div class="giga-button">
        <button class="giga-green_button no-icon" @click="onValidate">
          {{ $t("submit") }}
        </button>
      </div>
    </div>
  </b-modal>
</template>


<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { queryConstant } from "../../shared/queryConstant";

export default {
  name: "DeleteSimulationReasonModal",
  props: {
    modalTitle: String,
    content: String,
    reasonData: Object,
  },
  data() {
    return {
      reason: "",
      message: "",
      reasonOptions: queryConstant.SIMULATION_LOST_REASONS.map(opt => ({
        value: opt.value,
        text: opt.name,
      })),
    };
  },
  validations: {
    reason: { required },
    message: {
      required: requiredIf(function () {
        return this.reason === "AUTRE";
      }),
    },
  },
  computed: {
    messagePlaceholder() {
      return this.reason === "AUTRE"
          ? "Pourquoi souhaitez-vous supprimer cette simulation ?"
          : "Message libre (optionnel)";
    },
  },
  mounted() {
    this.$root.$on("bv::show::modal", (modalId) => {
      if (modalId === "delete-simulation-reason") {
        if (this.reasonData?.reason || this.reasonData?.message) {
          this.reason = this.reasonData.reason;
          this.message = this.reasonData.message;
          this.$v.$reset();
        } else {
          this.resetForm();
        }
      }
    });
  },

  methods: {
    handleReasonChange() {
      if (this.reason === "AUTRE") {
        this.$v.message.$reset();
      } else {
        this.message = "";
        this.$v.message.$reset();
      }
    },
    resetForm() {
      this.reason = "";
      this.message = "";
      this.$v.$reset();
    },
    onValidate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit("reasonSubmitted", {
        reason: this.reason,
        message: this.message,
      });

      this.$root.$emit("bv::hide::modal", "delete-simulation-reason");
    },
    onCancel() {
      this.resetForm();
      this.$emit("cancel");
      this.$root.$emit("bv::hide::modal", "delete-simulation-reason");
    },
  },
};
</script>


<style scoped>
.giga-modal_body {
  flex: 1;
  margin-top: 1px;
  height: auto !important;
  min-height: 100px;
  margin-bottom: 20px;
}
.custom-select,
.input-field_area textarea {
  height: 54px;
  border-radius: 6px;
  border: 2px solid #8c9dab;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 500;
  color: #132d48;
  background-color: #ffffff;
  transition: all 0.2s linear;
}

</style>